<template>
  <div class="card card-hover p-6 group">
    <div :class="['w-11 h-11 rounded-xl flex items-center justify-center transition-transform duration-300 group-hover:-rotate-3', iconWrapClass]">
      <Icon :name="icon" :size="20" />
    </div>
    <h3 class="mt-5 text-lg font-semibold text-ink-900 tracking-tight">{{ title }}</h3>
    <p class="mt-1.5 text-sm text-ink-600 leading-relaxed">{{ body }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '../ui/Icon.vue';

const props = defineProps({
  icon:   { type: String, required: true },
  title:  { type: String, required: true },
  body:   { type: String, required: true },
  accent: { type: String, default: 'brand' }, // brand | accent | ink
});

const iconWrapClass = computed(() => ({
  brand:  'bg-brand-50 text-brand-700',
  accent: 'bg-accent-50 text-accent-700',
  ink:    'bg-ink-100 text-ink-700',
}[props.accent] || 'bg-brand-50 text-brand-700'));
</script>
